// extracted by mini-css-extract-plugin
export default {"container":"Dl-z","blurb":"El-z","links":"Fl-z"};